/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringListResult } from '../../models/string-list-result';

export interface ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Params {
}

export function apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
  const rb = new RequestBuilder(rootUrl, apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringListResult>;
    })
  );
}

apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse.PATH = '/api/team/teams/evanmiya';
